import PreInvoice from './PreInvoice';
import RedirectToCart from './RedirectToCart';
import { Chip } from '@mui/material';

const cart = (params) => {
  return <RedirectToCart {...params.row} />;
};

const preInvoice = (params) => {
  return <PreInvoice {...params.row} />;
};

const handleEnrollmentType = (params) => {
  return (
    <Chip
      label={params.row.isCartEnrolled === 0 ? 'LeadSquared' : 'Cart'}
      variant="outlined"
      color="primary"
      size="small"
    />
  );
};

export const QUALIFIED_LEADS_TABLE_HEAD = (rows) => {
  const columns = [
    {
      field: 'sl_no',
      headerName: 'slNo',
      width: 20,
    },
    {
      field: 'leadId',
      headerName: 'Lead Id',
      width: 150,
    },
    {
      field: 'name',
      headerName: 'Lead Name',
      width: 300,
    },
    {
      field: 'lead_mob_no',
      headerName: 'Phone',
      width: 150,
    },
    {
      field: 'leadTime',
      headerName: 'Date',
      width: 300,
    },
    {
      field: 'Cart',
      headerName: 'Cart',
      width: 250,
      renderCell: cart,
    },

    {
      field: 'PreInvoice',
      headerName: 'PreInvoice',
      width: 150,
      renderCell: preInvoice,
    },
  ];
  const hasIsCartEnrolled = rows?.some((row) => Object.prototype.hasOwnProperty.call(row, 'isCartEnrolled'));

  if (hasIsCartEnrolled) {
    columns.splice(4, 0, {
      field: 'isCartEnrolled',
      headerName: 'Enrollment Type',
      width: 200,
      renderCell: handleEnrollmentType,
    });
  }

  return columns;
};
